import useKeyboardShortcutsPaneState from "./hooks/useKeyboardShortcutsPaneState";
import KeyboardShortcutsPane from "./Pane";
import { getGlobalShortcuts } from "./Pane/utils";

const KeyboardShortcuts = {
  Pane: KeyboardShortcutsPane,
  usePaneState: useKeyboardShortcutsPaneState,
  GLOBAL_SHORTCUTS: getGlobalShortcuts(),
};

export default KeyboardShortcuts;
